import script from "./ProjectStatusProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectStatusProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./ProjectStatusProgressBar.vue?vue&type=style&index=0&id=000dbf0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-000dbf0e"]])

export default __exports__